import React, { useEffect, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { DepotoCore } from 'depoto-core'
import { Loader } from '../components'
import { useLogin } from '../hooks'

type Props = {
  core: DepotoCore
}

/**
 * OAuth login via URL query string (GET).
 */
export const ExternalLogin: React.FC<Props> = ({ core }) => {
  const { handleExternalLogin } = useLogin()
  const history = useHistory()
  const location = useLocation()
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) {
      return
    }
    ran.current = true
    void (async () => {
      const ok = await handleExternalLogin(core, location.search)
      if (ok) {
        history.replace('/dashboard')
      } else {
        history.replace('/login')
      }
    })()
  }, [core, location.search, handleExternalLogin, history])

  return <Loader />
}
